// This is a dummy empty module for Vite aliasing Node.js modules in the frontend build.
export default {}; 